import { SvgIcon, SvgIconProps } from "@/domains/icons/svg-icon"

export const FeesIcon = ({ ...rest }: SvgIconProps) => {
  return (
    <SvgIcon {...rest}>
      <path
        d="M14.5004 12C14.5004 13.3807 13.3811 14.5 12.0004 14.5C10.6197 14.5 9.50043 13.3807 9.50043 12C9.50043 10.6193 10.6197 9.5 12.0004 9.5C13.3811 9.5 14.5004 10.6193 14.5004 12Z"
        stroke="currentColor"
        strokeLinecap="square"
      />
      <path
        d="M16.0004 5C20.0004 5 22.0004 6 22.0004 6V19C22.0004 19 20.0004 18 16.0004 18C11.0004 18 10.0004 20 2.00043 18V5C10.0004 7 11.0004 5 16.0004 5Z"
        stroke="currentColor"
        strokeLinecap="square"
      />
      <path
        d="M2 9.00146C3.95133 9.00146 5.70483 7.40654 5.92901 5.75563M18.5005 5.50146C18.5005 7.54111 20.2655 9.47046 22 9.47046M22 15.0015C20.1009 15.0015 18.2601 16.3117 18.102 18.0998M6.00049 18.4976C6.00049 16.2884 4.20963 14.4976 2.00049 14.4976"
        stroke="currentColor"
        strokeLinecap="square"
      />
    </SvgIcon>
  )
}
